import * as React from 'react';
import { IStackStyles, Text, IStyle, Stack, useTheme} from '@fluentui/react';
interface INewOrderStepsProps {
    step: number;
    isAuth: boolean;
    smallScreen: boolean;
    middleScreen: boolean;
}

interface IStyles {
    style: Partial<IStackStyles>;
    setStyleSlected: Partial<IStackStyles>;

}

export const NewOrderSteps: React.FunctionComponent<INewOrderStepsProps> = (props) => {

    const [smallScreen, setSmallScreen] = React.useState(window.matchMedia("(max-width: 320px)").matches) 
    const [middleScreen, setMiddleScreen] = React.useState(window.matchMedia("(max-width: 470px)").matches) 

    const theme = useTheme();
    const [style, setStyle] = React.useState<IStyles>({
        style: {
            root: {
                minWidth: 140,
                width: props.smallScreen ? '100%' : props.middleScreen? '50%':'16%',
                maxWidth: 800,
                fontWeight: 400,
                fontFamily: "Comfortaa, serif"
            }
        },
        setStyleSlected: {
            root: {
                minWidth: 140,
                width: props.smallScreen ? '100%' : props.middleScreen ? '50%' : '16%',
                maxWidth: 800,
                fontWeight: 800,
                fontFamily: "Comfortaa, serif"
            }
        }
    })
 

    React.useEffect(() => {
        setStyle({
            style: {
                root: {
                    minWidth: 100,
                    width: props.smallScreen ? '100%' : props.middleScreen ? '50%' : '14.2%',
                    maxWidth: 800,
                    fontWeight: 400,
                    fontFamily: "Comfortaa, serif"
                }
            },
            setStyleSlected: {
                root: {
                    minWidth: 100,
                    width: props.smallScreen ? '100%' : props.middleScreen ? '50%' : '14.2%',
                    maxWidth: 800,
                    fontWeight: 800,
                    fontFamily: "Comfortaa, serif"
                }
            }
        })
    }, [props.smallScreen, props.middleScreen])


    const step = (step: number, text:string,color:string) => {

        return <Stack styles={props.step == step ? style.setStyleSlected : style.style}>
            <Stack styles={{ root: { padding: 5 } }}>
                <Text styles={{ root: { fontFamily: "Comfortaa, serif", color: props.step == step ? theme.palette.blue : theme.palette.neutralDark } }} >{text}</Text>
            </Stack>
            <Stack styles={{ root: { backgroundColor: props.step == step ? theme.palette.blue : color, height: 10 } }}>
            </Stack>
        </Stack>
    }

    return (<Stack verticalAlign="end" wrap horizontal tokens={{ childrenGap: 0 }}>
        
        {step(1, "1. Výběr kurzu","#E9E2E2")}
        {!props.isAuth ?
            step(2, "2. Zadání e-mailu/login","#D0C9C9"):null}
        {step(3, "3. Fakturační údaje","#B6AFAF") }
        {step(4, "4. Zadání žáka", "#9D9696")}
        {step(5, "5. Doplňující informace", "#8A8484")}
        {step(6, "6. Rekapitulace","#7D7777")}
        {step(7, "7. Potvrzení","#6A6363")}        
    </Stack>)
}
